module.exports = __webpack_public_path__ + "static/img/fund-logo-2.c9e73ce.webp";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/fund-logo-2.webp
// module id = 1Mml
// module chunks = 5